import React from "react";
import { useTranslation } from "react-i18next";

const InlineLoader = ({ className = "qr-menu-loading-indicator" }) => {
  const { t } = useTranslation();

  return (
    <div className={className} aria-label={t("loading")}>
      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </div>
  );
};

export default InlineLoader;
